import { types as t, getParent } from 'mobx-state-tree';
//import PropertyItem from './PropertyItem';

export default t.model("VariantGroup", {
    //Properties: t.optional(t.frozen(), {}),//t.optional(PropertyItem, {}),
    GroupByKey: t.maybeNull(t.string),
    GroupByValue: t.maybeNull(t.string),
    GroupByName: t.maybeNull(t.string),
    GroupUrlSlug: t.maybeNull(t.string),
    Images: t.optional(t.array(t.string), []),
    SortOrder:t.optional(t.number, 0)
}).views(self => ({
     

})).actions(self => ({

}));